module.exports = {"532601001":"开化街道","532601002":"卧龙街道","532601003":"新平街道","532601102":"古木镇","532601103":"平坝镇","532601104":"马塘镇","532601105":"德厚镇","532601106":"小街镇","532601107":"薄竹镇","532601108":"追栗街镇","532601201":"东山彝族乡","532601202":"柳井彝族乡","532601203":"新街乡","532601204":"喜古乡","532601205":"坝心彝族乡","532601206":"秉烈彝族乡","532601207":"红甸回族乡","532601401":"文山市三七产业园区管理委员会","532601402":"文山市马塘工业园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532601.json
// module id = 2637
// module chunks = 0